import { getAnimationConfiguration } from '../../hooks/helpers';
import animationData from '../../lotties/email.json';

export const defaultOptions = getAnimationConfiguration(animationData);
